// extracted by mini-css-extract-plugin
module.exports = {"itemRow1":"itemhistory_itemRow1__1buPg","itemRow2":"itemhistory_itemRow2__23Rl-"};